import { IComponentOptions } from 'angular';
import template from '../partials/email-sent.html';

export class EmailPopoverConfirmationController {
    onClose?: () => void;

    public hide(): void {
        this.onClose && this.onClose();
    }
}

export const EmailPopoverConfirmationComponent: IComponentOptions = {
    bindings: {
        onClose: '&',
    },
    controller: EmailPopoverConfirmationController,
    controllerAs: 'popover',
    template,
};
